
<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="分销商：">
                <el-input v-model="searchForm.agentName" clearable></el-input>
            </el-form-item>
            <el-form-item label="分销时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getSimDistributRecordHandler">搜索查询</el-button>
                <el-button type="primary" @click="showSimExcelDistribut">分销SIM卡</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border >
            <el-table-column prop="soldTime" label="分销时间" ></el-table-column>
            <el-table-column prop="agentName" label="分销商" ></el-table-column>
            <el-table-column prop="soldTotal" label="分销张数（张）" ></el-table-column>
            <el-table-column prop="soldSuccess" label="分销成功张数（张）" ></el-table-column>
            <el-table-column prop="soldFail" label="分销失败张数（张）" ></el-table-column>          
            <el-table-column prop="disposeName" label="操作人"></el-table-column>            
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.soldFail > 0" type="text" size="small" @click="getSimDistributFailRecordListHandler(scope.row.id, $event)">查看失败</el-button>
                </template> 
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    
        <el-dialog title="分销失败卡列表" :visible.sync="distributFailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="remark" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination> 
        </el-dialog>
        <el-dialog title="卡片批量分销" :visible.sync="batchDstVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="batchDistributForm" :model="batchDistributForm" label-width="120px">
                <el-form-item label="导入Excel：">
                    <el-upload ref="upload" :action="uploadUrl('sim/sold/insert')" :headers="setHeader()" :limit="1" :auto-upload="false" :multiple="false" :data="batchDistributForm" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle()">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="代理商：">
                    <el-select v-model="batchDistributForm.id" filterable clearable>
                        <el-option v-for="item in agentsOption" :value="item.accountId" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="simDistributHandler">确 定</el-button>
            </div> 
        </el-dialog> 
    </div>
</template>
<script>
import {getSimDistributRecord, getSimDistributFailRecordList} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                batchNo: '',
                time: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            distributFailVisible: false,
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },      
            currentId_fail: '',
            batchDstVisible: false,
            batchDistributForm: {
                id: ''
            },
            agentsOption: []
        }
    },
    methods: {
        cancel(){            
            this.batchDstVisible = false;    
            this.$refs.batchDistributForm.resetFields();  
        },
        getSimDistributRecordHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getSimDistributRecord(data).then(res => {
                common.listCallback(this, res, 'tbpg');               
            })            
        },
        getSimDistributFailRecordListHandler(id, $event){
            this.distributFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                id: this.currentId_fail,
                state: 2
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            getSimDistributFailRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showSimExcelDistribut(){
            this.batchDstVisible = true;
            common.getAgentListforCardDistube(this, 'agentsOption');           
        },
        simDistributHandler(){
            this.$refs.upload.submit();   //excel批量导入
        },
        exportHandle(){//导出excel文件
            var data = {};
            data.token = localStorage.getItem('token');
            this.exportExcel('/excel/sim/sold/template', data);
            this.$message.success('下载中……');
        },
        handleSuccess(res){
            if(res.code == 200){
                this.batchDstVisible = false;
                this.getSimDistributRecordHandler();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
        handleSizeChange(val){
            if(this.distributFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getSimDistributFailRecordListHandler(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getSimDistributRecordHandler();
            }
        },
        handleCurrentChange(val){
            if(this.distributFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getSimDistributFailRecordListHandler(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getSimDistributRecordHandler();
            }
        }
    },   
    created () {
        this.getSimDistributRecordHandler()
    } 
}
</script>
<style lang="less" scoped>

</style>

